export default "__VITE_ASSET__BtmF$JQg__"